import { Component, Input } from '@angular/core';
import { GraphicService } from '../../shared/graphic.service';
import { NgStyle } from '@angular/common';

@Component({
    selector: 'app-box-dist-entrega',
    templateUrl: './box-dist-entrega.component.html',
    styleUrls: ['./box-dist-entrega.component.css'],
    standalone: true,
    imports: [NgStyle]
})
export class BoxDistEntregaComponent {
  
  @Input() indice = 1;
  @Input() dados;
  cor: string;
  cores = ['#0009E1', '#E76203', '#237506'];

  constructor(private graphicService: GraphicService){}

  ngOnChanges(){
    const grupo = (this.indice - 1) % 3;
    this.cor = this.cores[grupo];
  }

  mudarCor(){
    this.graphicService.corDistanciaPercorrida = this.cor;
    this.graphicService.preparaListaDisPercorrida(this.dados);
  }
}
